import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef } from 'react';
import { useNavigate, useLocation, generatePath } from 'react-router';
import Loader from '@amzn/meridian/loader';
import { PrimeButton, YellowButton } from 'src/common/buttons';
import { routes } from 'src/utils/routes';
import { PreviewOrderStatus } from 'src/pages/previewOrderPage/utils';
import { usePageContext } from 'src/hooks/usePageContext';
import { useConfirmOrderMutation } from 'src/hooks/useConfirmOrders';
import { getExperimentArm } from 'src/utils/experiments';
import { useAnalyticsContext } from 'src/common/metrics';
import { isEnvironmentSecureForMFA } from 'src/utils/MFAEnvironmentIntegrity';
export const PurchaseButton = ({ isDisabled, previewOrderStatus, purchaseId, asin, refetch, isPrime, onGenericError, }) => {
    var _a;
    const { bundle, appData } = usePageContext();
    const navigate = useNavigate();
    const location = useLocation();
    const rumClient = useAnalyticsContext();
    const isVerifyOrderEnabled = getExperimentArm((_a = appData === null || appData === void 0 ? void 0 : appData.data) === null || _a === void 0 ? void 0 : _a.experiments, 'HANDSHAKE_PAINTER_VERIFY_ORDER_TYP') === 'T1';
    // Synchronous guard to prevent duplicate submissions from rapid clicks.
    const isSubmittingRef = useRef(false);
    const { mutate, isPending } = useConfirmOrderMutation({
        onGenericError,
        onSettled: () => {
            isSubmittingRef.current = false;
        },
    });
    const Button = isPrime ? PrimeButton : YellowButton;
    let localeKey = 'placeYourOrder';
    let onButtonClick = () => {
        if (isVerifyOrderEnabled) {
            if (isSubmittingRef.current)
                return;
            isSubmittingRef.current = true;
            mutate({ purchaseId: purchaseId, isEnvironmentSecureForMFA: isEnvironmentSecureForMFA(rumClient) });
        }
        else {
            // Control group: navigate directly to TYP (existing behavior)
            navigate(`${routes.thankYouPage}${location.search}`, {
                state: { purchaseId },
            });
        }
    };
    if (previewOrderStatus === PreviewOrderStatus.UNFIXABLE_ERROR) {
        localeKey = 'backToProduct';
        onButtonClick = () => {
            const url = generatePath(routes.productDetailPage, { asin });
            navigate(`${url}${location.search}`);
        };
    }
    else if (previewOrderStatus === PreviewOrderStatus.FIXABLE_ERROR) {
        localeKey = 'retry';
        onButtonClick = refetch;
    }
    return (_jsx(Button, { disabled: isDisabled || isPending, onClick: onButtonClick, "data-testid": "purchase-button", children: isPending ? _jsx(Loader, { size: "small" }) : bundle.getMessage(localeKey) }));
};
